import React, { useState } from "react";

import { IconButton, InputAdornment, OutlinedInput } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import SearchIcon from "@mui/icons-material/Search";


function SearchField({ onSearch, onClear = null, label = 'Search', placeholder = 'Search', searchText = '' }) {
    const [searchString, setSearchString] = useState(searchText);

    const handleSubmit = () => {
        if (!!searchString) {
            onSearch(searchString);
        }
    };
    const handleClear = () => {
        setSearchString('');
        if (!!onClear) {
            onClear();
        }
    }


    return (
        <OutlinedInput
            id="text-search"
            placeholder={placeholder}
            value={searchString}
            onChange={({ target }) => setSearchString(target.value)}
            inputProps={{ maxLength: 250 }}
            endAdornment={
                <InputAdornment position="end">
                    {!!searchString && (
                        <IconButton
                            aria-label="clear search results"
                            onClick={handleClear}
                            edge="end"
                        >
                            <ClearIcon />
                        </IconButton>
                    )}
                    <IconButton
                        aria-label={label}
                        onClick={handleSubmit}
                        edge="end"
                        disabled={!searchString}
                    >
                        <SearchIcon />
                    </IconButton>
                </InputAdornment>
            }
        />
    );
}

export default SearchField;
